var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3159_4757)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3159_4757",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3159_4757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95273 7.71636C6.62773 7.46773 7.28417 8.12417 7.03555 8.79973L5.56349 12.8014C5.53091 12.89 5.47654 12.969 5.40538 13.0312C5.33422 13.0933 5.24856 13.1365 5.15631 13.1567C5.06407 13.177 4.96819 13.1738 4.87754 13.1472C4.78689 13.1207 4.70438 13.0718 4.63761 13.005L1.74748 10.1149C1.6808 10.0481 1.63199 9.96561 1.60555 9.87502C1.5791 9.78444 1.57587 9.68865 1.59615 9.59649C1.61643 9.50433 1.65957 9.41875 1.7216 9.34764C1.78363 9.27652 1.86256 9.22216 1.95111 9.18954L5.95273 7.71636Z",
    fill: "url(#paint0_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95273 7.71636C6.62773 7.46773 7.28417 8.12417 7.03555 8.79973L5.56349 12.8014C5.53091 12.89 5.47654 12.969 5.40538 13.0312C5.33422 13.0933 5.24856 13.1365 5.15631 13.1567C5.06407 13.177 4.96819 13.1738 4.87754 13.1472C4.78689 13.1207 4.70438 13.0718 4.63761 13.005L1.74748 10.1149C1.6808 10.0481 1.63199 9.96561 1.60555 9.87502C1.5791 9.78444 1.57587 9.68865 1.59615 9.59649C1.61643 9.50433 1.65957 9.41875 1.7216 9.34764C1.78363 9.27652 1.86256 9.22216 1.95111 9.18954L5.95273 7.71636Z",
    fill: "url(#paint1_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95273 7.71636C6.62773 7.46773 7.28417 8.12417 7.03555 8.79973L5.56349 12.8014C5.53091 12.89 5.47654 12.969 5.40538 13.0312C5.33422 13.0933 5.24856 13.1365 5.15631 13.1567C5.06407 13.177 4.96819 13.1738 4.87754 13.1472C4.78689 13.1207 4.70438 13.0718 4.63761 13.005L1.74748 10.1149C1.6808 10.0481 1.63199 9.96561 1.60555 9.87502C1.5791 9.78444 1.57587 9.68865 1.59615 9.59649C1.61643 9.50433 1.65957 9.41875 1.7216 9.34764C1.78363 9.27652 1.86256 9.22216 1.95111 9.18954L5.95273 7.71636Z",
    fill: "url(#paint2_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32732 11.0914C10.0023 10.8427 10.6588 11.4992 10.4101 12.1747L8.93695 16.1764C8.90433 16.2649 8.84997 16.3438 8.77885 16.4059C8.70774 16.4679 8.62216 16.511 8.53 16.5313C8.43784 16.5516 8.34205 16.5484 8.25147 16.5219C8.16088 16.4955 8.07841 16.4467 8.01163 16.38L5.12151 13.4899C5.05483 13.4231 5.00602 13.3406 4.97957 13.25C4.95313 13.1594 4.94989 13.0637 4.97018 12.9715C4.99046 12.8793 5.0336 12.7938 5.09563 12.7226C5.15766 12.6515 5.23658 12.5972 5.32513 12.5645L9.32732 11.0914Z",
    fill: "url(#paint3_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32732 11.0914C10.0023 10.8427 10.6588 11.4992 10.4101 12.1747L8.93695 16.1764C8.90433 16.2649 8.84997 16.3438 8.77885 16.4059C8.70774 16.4679 8.62216 16.511 8.53 16.5313C8.43784 16.5516 8.34205 16.5484 8.25147 16.5219C8.16088 16.4955 8.07841 16.4467 8.01163 16.38L5.12151 13.4899C5.05483 13.4231 5.00602 13.3406 4.97957 13.25C4.95313 13.1594 4.94989 13.0637 4.97018 12.9715C4.99046 12.8793 5.0336 12.7938 5.09563 12.7226C5.15766 12.6515 5.23658 12.5972 5.32513 12.5645L9.32732 11.0914Z",
    fill: "url(#paint4_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32732 11.0914C10.0023 10.8427 10.6588 11.4992 10.4101 12.1747L8.93695 16.1764C8.90433 16.2649 8.84997 16.3438 8.77885 16.4059C8.70774 16.4679 8.62216 16.511 8.53 16.5313C8.43784 16.5516 8.34205 16.5484 8.25147 16.5219C8.16088 16.4955 8.07841 16.4467 8.01163 16.38L5.12151 13.4899C5.05483 13.4231 5.00602 13.3406 4.97957 13.25C4.95313 13.1594 4.94989 13.0637 4.97018 12.9715C4.99046 12.8793 5.0336 12.7938 5.09563 12.7226C5.15766 12.6515 5.23658 12.5972 5.32513 12.5645L9.32732 11.0914Z",
    fill: "url(#paint5_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3159_4757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 1.99685C12.6157 1.99075 12.6325 1.9893 12.6487 1.9927C12.6649 1.99611 12.6798 2.0042 12.6914 2.01598L16.0017 5.3516C16.0134 5.3633 16.0214 5.37817 16.0247 5.39437C16.028 5.41057 16.0264 5.42739 16.0203 5.44272C15.2271 7.38897 14.1342 9.45897 12.6711 10.9226C11.2458 12.348 8.8349 13.5624 6.65802 14.4557L3.56934 11.3664C4.46259 9.18954 5.67702 6.77922 7.1024 5.35385C8.57052 3.88572 10.6484 2.79054 12.5997 1.99741",
    fill: "url(#paint6_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 1.99685C12.6157 1.99075 12.6325 1.9893 12.6487 1.9927C12.6649 1.99611 12.6798 2.0042 12.6914 2.01598L16.0017 5.3516C16.0134 5.3633 16.0214 5.37817 16.0247 5.39437C16.028 5.41057 16.0264 5.42739 16.0203 5.44272C15.2271 7.38897 14.1342 9.45897 12.6711 10.9226C11.2458 12.348 8.8349 13.5624 6.65802 14.4557L3.56934 11.3664C4.46259 9.18954 5.67702 6.77922 7.1024 5.35385C8.57052 3.88572 10.6484 2.79054 12.5997 1.99741",
    fill: "url(#paint7_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 1.99685C12.6157 1.99075 12.6325 1.9893 12.6487 1.9927C12.6649 1.99611 12.6798 2.0042 12.6914 2.01598L16.0017 5.3516C16.0134 5.3633 16.0214 5.37817 16.0247 5.39437C16.028 5.41057 16.0264 5.42739 16.0203 5.44272C15.2271 7.38897 14.1342 9.45897 12.6711 10.9226C11.2458 12.348 8.8349 13.5624 6.65802 14.4557L3.56934 11.3664C4.46259 9.18954 5.67702 6.77922 7.1024 5.35385C8.57052 3.88572 10.6484 2.79054 12.5997 1.99741",
    fill: "url(#paint8_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 1.99685C12.6157 1.99075 12.6325 1.9893 12.6487 1.9927C12.6649 1.99611 12.6798 2.0042 12.6914 2.01598L16.0017 5.3516C16.0134 5.3633 16.0214 5.37817 16.0247 5.39437C16.028 5.41057 16.0264 5.42739 16.0203 5.44272C15.2271 7.38897 14.1342 9.45897 12.6711 10.9226C11.2458 12.348 8.8349 13.5624 6.65802 14.4557L3.56934 11.3664C4.46259 9.18954 5.67702 6.77922 7.1024 5.35385C8.57052 3.88572 10.6484 2.79054 12.5997 1.99741",
    fill: "url(#paint9_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 1.99685C12.6157 1.99075 12.6325 1.9893 12.6487 1.9927C12.6649 1.99611 12.6798 2.0042 12.6914 2.01598L16.0017 5.3516C16.0134 5.3633 16.0214 5.37817 16.0247 5.39437C16.028 5.41057 16.0264 5.42739 16.0203 5.44272C15.2271 7.38897 14.1342 9.45897 12.6711 10.9226C11.2458 12.348 8.8349 13.5624 6.65802 14.4557L3.56934 11.3664C4.46259 9.18954 5.67702 6.77922 7.1024 5.35385C8.57052 3.88572 10.6484 2.79054 12.5997 1.99741",
    fill: "url(#paint10_radial_3159_4757)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_3159_4757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7817 6.22236C13.786 6.47326 13.7403 6.72252 13.6473 6.95558C13.5543 7.18864 13.4158 7.40085 13.2399 7.57981C13.064 7.75878 12.8542 7.90093 12.6227 7.99796C12.3913 8.09499 12.1429 8.14496 11.892 8.14496C11.641 8.14496 11.3926 8.09499 11.1612 7.99796C10.9297 7.90093 10.7199 7.75878 10.544 7.57981C10.3681 7.40085 10.2296 7.18864 10.1366 6.95558C10.0436 6.72252 9.99791 6.47326 10.0022 6.22236C10.0108 5.72682 10.2136 5.25446 10.5671 4.90705C10.9206 4.55963 11.3963 4.36496 11.892 4.36496C12.3876 4.36496 12.8633 4.55963 13.2168 4.90705C13.5703 5.25446 13.7731 5.72682 13.7817 6.22236Z",
    fill: "url(#paint11_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7817 6.22236C13.786 6.47326 13.7403 6.72252 13.6473 6.95558C13.5543 7.18864 13.4158 7.40085 13.2399 7.57981C13.064 7.75878 12.8542 7.90093 12.6227 7.99796C12.3913 8.09499 12.1429 8.14496 11.892 8.14496C11.641 8.14496 11.3926 8.09499 11.1612 7.99796C10.9297 7.90093 10.7199 7.75878 10.544 7.57981C10.3681 7.40085 10.2296 7.18864 10.1366 6.95558C10.0436 6.72252 9.99791 6.47326 10.0022 6.22236C10.0108 5.72682 10.2136 5.25446 10.5671 4.90705C10.9206 4.55963 11.3963 4.36496 11.892 4.36496C12.3876 4.36496 12.8633 4.55963 13.2168 4.90705C13.5703 5.25446 13.7731 5.72682 13.7817 6.22236Z",
    fill: "url(#paint12_radial_3159_4757)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 6.22235C13.2036 6.39641 13.1724 6.56945 13.1083 6.73131C13.0442 6.89318 12.9484 7.04062 12.8266 7.165C12.7047 7.28937 12.5593 7.38819 12.3988 7.45565C12.2383 7.5231 12.066 7.55785 11.8919 7.55785C11.7178 7.55785 11.5454 7.5231 11.3849 7.45565C11.2244 7.38819 11.079 7.28937 10.9572 7.165C10.8353 7.04062 10.7396 6.89318 10.6754 6.73131C10.6113 6.56945 10.5802 6.39641 10.5838 6.22235C10.5909 5.88012 10.7318 5.5543 10.9764 5.31477C11.2209 5.07525 11.5496 4.9411 11.8919 4.9411C12.2342 4.9411 12.5628 5.07525 12.8074 5.31477C13.0519 5.5543 13.1929 5.88012 13.2 6.22235Z",
    fill: "url(#paint13_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3159_4757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36312 16.6123C0.965436 16.2146 1.12519 13.4561 2.53144 12.8936C2.53144 12.8936 3.93769 12.3311 4.84387 13.2311C5.75006 14.1311 5.34394 15.1436 5.34394 15.1436C4.94625 16.3367 3.25312 16.8109 3.054 16.6117C2.94431 16.502 3.14175 16.3024 3.054 16.2146C2.96625 16.1263 2.83012 16.227 2.45775 16.4132C2.19225 16.5459 1.52231 16.7715 1.36312 16.6123Z",
    fill: "url(#paint14_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36312 16.6123C0.965436 16.2146 1.12519 13.4561 2.53144 12.8936C2.53144 12.8936 3.93769 12.3311 4.84387 13.2311C5.75006 14.1311 5.34394 15.1436 5.34394 15.1436C4.94625 16.3367 3.25312 16.8109 3.054 16.6117C2.94431 16.502 3.14175 16.3024 3.054 16.2146C2.96625 16.1263 2.83012 16.227 2.45775 16.4132C2.19225 16.5459 1.52231 16.7715 1.36312 16.6123Z",
    fill: "url(#paint15_radial_3159_4757)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.40894 11.8024C3.4873 11.724 3.58034 11.6618 3.68274 11.6193C3.78514 11.5769 3.8949 11.5551 4.00575 11.5551C4.1166 11.5551 4.22636 11.5769 4.32877 11.6193C4.43117 11.6618 4.52421 11.724 4.60257 11.8024L6.591 13.7914C6.74202 13.951 6.82483 14.1632 6.82183 14.3829C6.81883 14.6025 6.73025 14.8124 6.57492 14.9678C6.4196 15.1232 6.20978 15.2119 5.99009 15.215C5.7704 15.2181 5.55816 15.1354 5.3985 14.9844L3.40894 12.996C3.33053 12.9176 3.26834 12.8246 3.2259 12.7222C3.18346 12.6198 3.16162 12.51 3.16162 12.3992C3.16162 12.2883 3.18346 12.1786 3.2259 12.0762C3.26834 11.9738 3.33053 11.8807 3.40894 11.8024Z",
    fill: "url(#paint16_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40894 11.8024C3.4873 11.724 3.58034 11.6618 3.68274 11.6193C3.78514 11.5769 3.8949 11.5551 4.00575 11.5551C4.1166 11.5551 4.22636 11.5769 4.32877 11.6193C4.43117 11.6618 4.52421 11.724 4.60257 11.8024L6.591 13.7914C6.74202 13.951 6.82483 14.1632 6.82183 14.3829C6.81883 14.6025 6.73025 14.8124 6.57492 14.9678C6.4196 15.1232 6.20978 15.2119 5.99009 15.215C5.7704 15.2181 5.55816 15.1354 5.3985 14.9844L3.40894 12.996C3.33053 12.9176 3.26834 12.8246 3.2259 12.7222C3.18346 12.6198 3.16162 12.51 3.16162 12.3992C3.16162 12.2883 3.18346 12.1786 3.2259 12.0762C3.26834 11.9738 3.33053 11.8807 3.40894 11.8024Z",
    fill: "url(#paint17_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40894 11.8024C3.4873 11.724 3.58034 11.6618 3.68274 11.6193C3.78514 11.5769 3.8949 11.5551 4.00575 11.5551C4.1166 11.5551 4.22636 11.5769 4.32877 11.6193C4.43117 11.6618 4.52421 11.724 4.60257 11.8024L6.591 13.7914C6.74202 13.951 6.82483 14.1632 6.82183 14.3829C6.81883 14.6025 6.73025 14.8124 6.57492 14.9678C6.4196 15.1232 6.20978 15.2119 5.99009 15.215C5.7704 15.2181 5.55816 15.1354 5.3985 14.9844L3.40894 12.996C3.33053 12.9176 3.26834 12.8246 3.2259 12.7222C3.18346 12.6198 3.16162 12.51 3.16162 12.3992C3.16162 12.2883 3.18346 12.1786 3.2259 12.0762C3.26834 11.9738 3.33053 11.8807 3.40894 11.8024Z",
    fill: "url(#paint18_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4093 1.61493C15.8766 1.08224 14.9423 1.14243 14.2616 1.37643C13.7481 1.55251 13.2391 1.74138 12.735 1.94286C12.7264 1.94631 12.7188 1.95184 12.7128 1.95894C12.7069 1.96604 12.7028 1.97451 12.7009 1.98358C12.699 1.99266 12.6994 2.00206 12.702 2.01095C12.7046 2.01984 12.7094 2.02795 12.7159 2.03455L15.984 5.32461C15.9906 5.33101 15.9986 5.3357 16.0074 5.33829C16.0162 5.34087 16.0255 5.34126 16.0345 5.33943C16.0435 5.3376 16.0519 5.3336 16.059 5.32779C16.066 5.32197 16.0716 5.31451 16.0751 5.30605C16.2791 4.79664 16.4703 4.28216 16.6483 3.76311C16.879 3.09149 17.0646 2.27024 16.4093 1.61493Z",
    fill: "url(#paint19_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4093 1.61493C15.8766 1.08224 14.9423 1.14243 14.2616 1.37643C13.7481 1.55251 13.2391 1.74138 12.735 1.94286C12.7264 1.94631 12.7188 1.95184 12.7128 1.95894C12.7069 1.96604 12.7028 1.97451 12.7009 1.98358C12.699 1.99266 12.6994 2.00206 12.702 2.01095C12.7046 2.01984 12.7094 2.02795 12.7159 2.03455L15.984 5.32461C15.9906 5.33101 15.9986 5.3357 16.0074 5.33829C16.0162 5.34087 16.0255 5.34126 16.0345 5.33943C16.0435 5.3376 16.0519 5.3336 16.059 5.32779C16.066 5.32197 16.0716 5.31451 16.0751 5.30605C16.2791 4.79664 16.4703 4.28216 16.6483 3.76311C16.879 3.09149 17.0646 2.27024 16.4093 1.61493Z",
    fill: "url(#paint20_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4093 1.61493C15.8766 1.08224 14.9423 1.14243 14.2616 1.37643C13.7481 1.55251 13.2391 1.74138 12.735 1.94286C12.7264 1.94631 12.7188 1.95184 12.7128 1.95894C12.7069 1.96604 12.7028 1.97451 12.7009 1.98358C12.699 1.99266 12.6994 2.00206 12.702 2.01095C12.7046 2.01984 12.7094 2.02795 12.7159 2.03455L15.984 5.32461C15.9906 5.33101 15.9986 5.3357 16.0074 5.33829C16.0162 5.34087 16.0255 5.34126 16.0345 5.33943C16.0435 5.3376 16.0519 5.3336 16.059 5.32779C16.066 5.32197 16.0716 5.31451 16.0751 5.30605C16.2791 4.79664 16.4703 4.28216 16.6483 3.76311C16.879 3.09149 17.0646 2.27024 16.4093 1.61493Z",
    fill: "url(#paint21_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63982 9.40386C8.31482 9.15523 8.97126 9.81167 8.72263 10.4872L7.25001 14.4889C7.21743 14.5775 7.16306 14.6565 7.0919 14.7187C7.02074 14.7808 6.93509 14.824 6.84284 14.8442C6.75059 14.8645 6.65472 14.8613 6.56407 14.8347C6.47341 14.8082 6.3909 14.7593 6.32413 14.6925L3.43401 11.8024C3.36733 11.7356 3.31852 11.6531 3.29207 11.5625C3.26563 11.4719 3.26239 11.3762 3.28268 11.284C3.30296 11.1918 3.3461 11.1063 3.40813 11.0351C3.47016 10.964 3.54908 10.9097 3.63763 10.877L7.63982 9.40386Z",
    fill: "url(#paint22_linear_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63982 9.40386C8.31482 9.15523 8.97126 9.81167 8.72263 10.4872L7.25001 14.4889C7.21743 14.5775 7.16306 14.6565 7.0919 14.7187C7.02074 14.7808 6.93509 14.824 6.84284 14.8442C6.75059 14.8645 6.65472 14.8613 6.56407 14.8347C6.47341 14.8082 6.3909 14.7593 6.32413 14.6925L3.43401 11.8024C3.36733 11.7356 3.31852 11.6531 3.29207 11.5625C3.26563 11.4719 3.26239 11.3762 3.28268 11.284C3.30296 11.1918 3.3461 11.1063 3.40813 11.0351C3.47016 10.964 3.54908 10.9097 3.63763 10.877L7.63982 9.40386Z",
    fill: "url(#paint23_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63982 9.40386C8.31482 9.15523 8.97126 9.81167 8.72263 10.4872L7.25001 14.4889C7.21743 14.5775 7.16306 14.6565 7.0919 14.7187C7.02074 14.7808 6.93509 14.824 6.84284 14.8442C6.75059 14.8645 6.65472 14.8613 6.56407 14.8347C6.47341 14.8082 6.3909 14.7593 6.32413 14.6925L3.43401 11.8024C3.36733 11.7356 3.31852 11.6531 3.29207 11.5625C3.26563 11.4719 3.26239 11.3762 3.28268 11.284C3.30296 11.1918 3.3461 11.1063 3.40813 11.0351C3.47016 10.964 3.54908 10.9097 3.63763 10.877L7.63982 9.40386Z",
    fill: "url(#paint24_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63982 9.40386C8.31482 9.15523 8.97126 9.81167 8.72263 10.4872L7.25001 14.4889C7.21743 14.5775 7.16306 14.6565 7.0919 14.7187C7.02074 14.7808 6.93509 14.824 6.84284 14.8442C6.75059 14.8645 6.65472 14.8613 6.56407 14.8347C6.47341 14.8082 6.3909 14.7593 6.32413 14.6925L3.43401 11.8024C3.36733 11.7356 3.31852 11.6531 3.29207 11.5625C3.26563 11.4719 3.26239 11.3762 3.28268 11.284C3.30296 11.1918 3.3461 11.1063 3.40813 11.0351C3.47016 10.964 3.54908 10.9097 3.63763 10.877L7.63982 9.40386Z",
    fill: "url(#paint25_radial_3159_4757)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3159_4757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.17822 12.4014L8.34229 9.92249L6.30322 13.5439L5.17822 12.4014Z",
    fill: "url(#paint26_linear_3159_4757)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3159_4757",
    x: 3.44434,
    y: 1.74091,
    width: 12.582,
    height: 12.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.125,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745098 0 0 0 0 0.772549 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3159_4757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_3159_4757",
    x: 9.50195,
    y: 3.98996,
    width: 4.77979,
    height: 4.78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.764706 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3159_4757"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3159_4757",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.721569 0 0 0 0 0.690196 0 0 0 0 0.701961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3159_4757"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.560784 0 0 0 0 0.65098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3159_4757",
    result: "effect3_innerShadow_3159_4757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3159_4757",
    x: 1.17432,
    y: 12.62,
    width: 4.26025,
    height: 4.04705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.505882 0 0 0 0 0.360784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3159_4757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3159_4757",
    x: 4.67822,
    y: 9.42249,
    width: 4.16406,
    height: 4.62137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_3159_4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3159_4757",
    x1: 4.5628,
    y1: 9.73573,
    x2: 1.7503,
    y2: 9.27223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63E7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.34923 9.59792) rotate(-19.9576) scale(4.50094 0.765255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#FF8DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8DB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3159_4757",
    x1: 2.75942,
    y1: 11.0998,
    x2: 3.21786,
    y2: 10.6526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#DD467C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD467C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3159_4757",
    x1: 10.0642,
    y1: 12.1905,
    x2: 6.56657,
    y2: 14.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3190"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.20093 12.489) rotate(86.482) scale(4.29698 3.70466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E76CBE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#E76CBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.56782 14.7566) rotate(-57.346) scale(2.96466 1.30223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3159_4757",
    x1: 7.58615,
    y1: 4.87797,
    x2: 12.5429,
    y2: 9.87016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD2EC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4834 12.137) rotate(-142.447) scale(9.38076 17.6334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E7E5E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.16459 11.9868) rotate(-56.929) scale(5.51464 2.59183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#B5A3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A3A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.56895 11.301) rotate(-73.625) scale(4.88879 0.828394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#B28F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28F96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2496 3.99935) rotate(137.284) scale(7.41094 2.30101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAECF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3159_4757",
    x1: 10.0022,
    y1: 5.90117,
    x2: 13.7817,
    y2: 6.22236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A796A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5959F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8928 6.22236) rotate(90) scale(1.88965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#93859B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93859B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8916 7.53072) rotate(-90) scale(2.72564 2.50665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#66ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B57F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.60762 13.6389) rotate(135) scale(3.26613 2.56725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9542"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.67119 16.2956) rotate(-131.186) scale(4.03567 4.25293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FFC484",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3159_4757",
    x1: 3.26157,
    y1: 12.3486,
    x2: 6.35532,
    y2: 15.3894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#452860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51509F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.84207 12.0673) rotate(77.8285) scale(0.9171 0.810282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E839A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E839A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.05413 12.6101) rotate(47.9357) scale(3.49442 1.8317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6175B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6175B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3159_4757",
    x1: 16.4121,
    y1: 1.61774,
    x2: 14.3443,
    y2: 3.68549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED224B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1657 2.4457) rotate(135) scale(4.63881 1.11358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#FF5971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5971",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3159_4757",
    x1: 14.5249,
    y1: 3.8233,
    x2: 14.7313,
    y2: 3.60786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2575E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93251",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3159_4757",
    x1: 8.52745,
    y1: 9.59904,
    x2: 4.87907,
    y2: 13.2474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2982"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.5077 10.9249) rotate(-20.865) scale(4.19502 1.09822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF95AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF95AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.03632 11.4232) rotate(44.7044) scale(2.59325 0.76602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#E14678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3159_4757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.5137 10.7662) rotate(84.6743) scale(4.16642 4.43993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#E67BC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67BC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3159_4757",
    x1: 7.86754,
    y1: 10.1863,
    x2: 5.54722,
    y2: 12.6124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5794"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3159_4757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.621772c7d527631ffaedaf013b8e6577.svg";
export { ForwardRef as ReactComponent };